import { render } from "./SmallPagination.vue?vue&type=template&id=5ca9b63e"
import script from "./SmallPagination.vue?vue&type=script&lang=ts"
export * from "./SmallPagination.vue?vue&type=script&lang=ts"
script.render = render

export default script